import * as Payment_en from './Payment.en.js';
import * as Payment_es from './Payment.es.js';

const PaymentTuple = [
  { type: 'Payment', language: 'en', object: Payment_en.default },
  { type: 'Payment', language: 'es', object: Payment_es.default },
];

export default PaymentTuple;
